// @flow
import React, { Fragment } from 'react';
import { Flex } from '@finect/tabular-core/Flex';
import { getSuperPartnerBaseURL } from '@finect/front-utils/env';
import { Section } from '@finect/tabular-components/Section';
import { PillModal } from '@finect/tabular-components/Pills';
import { SkeletonChart } from '@finect/tabular-components/Skeleton';
import { Jumbo } from '@finect/tabular-components/Jumbo';
import { DateLabel } from '@finect/tabular-components/DateLabel';
import {
  SummaryPanel,
  SummaryBlock,
  PillSummary,
  SummaryValueBlock,
  WrapperSummary,
  HealthMetric,
  Button
} from './partials';

const pillsBaseURL = getSuperPartnerBaseURL();

const fields = [
  {
    title: 'Controlas tu gasto',
    field: 'healthSpendingVersusIncomeLast12Months'
  },
  {
    title: 'Pagas bien tus facturas',
    field: 'healthBillPayment'
  },
  {
    title: 'Tienes un colchón',
    field: 'healthTimeExpensesCoveredWithoutIncome'
  },
  {
    title: 'Ahorras a largo plazo',
    field: 'healthConfidenceLongTermGoals'
  },
  {
    title: 'Tus deudas',
    field: 'healthDebtStatus'
  },
  {
    title: 'Te darían más préstamos',
    field: 'healthDeclaredCreditScore'
  },
  {
    title: 'Estás bien asegurado',
    field: 'healthConfidenceInsuranceSupport'
  },
  {
    title: 'Planificas tu futuro',
    field: 'healthAheadFinancialPlanning'
  }
];

const fieldsGroups = [
  {
    title: 'Gasto',
    fields: ['healthSpendingVersusIncomeLast12Months', 'healthBillPayment']
  },
  {
    title: 'Ahorro',
    fields: ['healthTimeExpensesCoveredWithoutIncome', 'healthConfidenceLongTermGoals']
  },
  {
    title: 'Deudas',
    fields: ['healthDebtStatus', 'healthDeclaredCreditScore']
  },
  {
    title: 'Planificación',
    fields: ['healthConfidenceInsuranceSupport', 'healthAheadFinancialPlanning']
  }
];

type Props = {
  app: Object,
  user: Object,
  onResults?: Function
};

type State = {
  pillOpen: boolean
};
export class Health extends React.Component<Props, State> {
  timeout = null;

  state = {
    pillOpen: false
  };

  handleTogglePill = () => {
    this.setState({ pillOpen: !this.state.pillOpen });
  };

  handleResults = () => {
    // 🚨 Hay un bug en el framework que hace que el eventos "results" se envíe varias veces y antes de tiempo
    this.timeout && clearTimeout(this.timeout);

    this.timeout = setTimeout(() => {
      this.props.onResults && this.props.onResults();
      this.setState({ pillOpen: false });
    }, 1000);
  };

  handlePillResults = () => {
    this.handleResults();
  };

  render() {
    const { app } = this.props;

    const healthFinancialValue =
      app.status === 'completed' && app.fields.length
        ? app.fields.find(item => item.field === 'healthFinancial')
        : null;

    const { value: healthFinancial = null } = healthFinancialValue || {};

    return (
      <Section bottomMargin title="Tu salud financiera" id="health">
        {this.state.pillOpen ? (
          <PillModal
            growOnResize={false}
            pill={`${pillsBaseURL}/pills/es_ES/finect/default/salud-financiera/healthSpendingVersusIncomeLast12Months`}
            onResultsPage={this.handlePillResults}
            onClose={this.handleTogglePill}
          />
        ) : null}

        <Fragment>
          {!app.fetched ? (
            <SkeletonChart />
          ) : app.sessionID && app.status === 'completed' && app.fields.length ? (
            <Fragment>
              <p>
                Tu salud financiera es de <HealthMetric>{healthFinancial}</HealthMetric> sobre un máximo de 100 puntos.
                La calculaste con nosotros el <DateLabel date={new Date(app.updated)} format={'L'} />.
              </p>

              <br />
              <WrapperSummary>
                <div>
                  {fieldsGroups.map((group, index) => (
                    <SummaryPanel key={`group-${index}`}>
                      <p>{group.title}</p>
                      <Flex>
                        {group.fields.map((fieldName) => {
                          const field: Object = fields.find(item => item.field === fieldName);
                          const value = app.fields.find(item => item.field === field.field).value;

                          return (
                            <SummaryBlock key={`field-${index}-${field.field}`}>
                              <div>{field.title}</div>
                              <SummaryValueBlock>
                                <div>
                                  {value}
                                  <small>/100</small>
                                </div>
                              </SummaryValueBlock>
                            </SummaryBlock>
                          );
                        })}
                      </Flex>
                    </SummaryPanel>
                  ))}
                </div>

                <PillSummary
                  src={`https://${process.env.FINECT_BASEURL || 'www.finect.com'}/pills/es_ES/finect/default/${
                    app.appID
                  }/${app.sessionID}/summary`}
                  scrolling={'no'}
                />
              </WrapperSummary>

              <Button width="auto" onClick={this.handleTogglePill}>
                Vuelve a calcular tu salud financiera
              </Button>
            </Fragment>
          ) : (
            <Jumbo
              id="salud-financiera"
              contentPosition="right"
              textAlign="right"
              color="#fff"
              title="Calcula tu salud financiera"
              cta="Analizar"
              coverImage="https://www.finect.com/image/82e13eb632e3c808625cc017d5fb32f05f8a7d3d45f"
              mainOnClick={this.handleTogglePill}
            />
          )}
        </Fragment>
      </Section>
    );
  }
}
